import { Helmet } from "react-helmet-async";
import { env } from "@/src/common/constants/env";
import { useAppSelector } from "@/src/common/redux/store";
import { getActiveCommunity } from "@/src/community/store/community-selectors";

interface PageHelmetProps {
	title: string;
	ogTitle?: string;
	ogDescription?: string;
	ogImage?: string | null;
	communityName?: string;
	communityImage?: string | null;
}

export function PageHelmet({ title, ogTitle, ogDescription, ogImage, communityName, communityImage }: PageHelmetProps) {
	const resolvedOgTitle = ogTitle ?? title;
	const selectedCommunity = useAppSelector(getActiveCommunity);

	const resolvedCommunityName = communityName ?? selectedCommunity?.name ?? env.APP_NAME;
	const resolvedCommunityImage = communityImage !== undefined ? communityImage : selectedCommunity?.image;

	return (
		<Helmet defaultTitle={env.APP_NAME} titleTemplate={`%s | ${resolvedCommunityName}`} title={title}>
			<link rel="icon" href={resolvedCommunityImage ?? "/favicon.ico"} />
			<meta property="og:title" content={resolvedOgTitle} />
			<meta name="twitter:title" content={resolvedOgTitle} />
			{ogDescription && <meta property="og:description" content={ogDescription} />}
			{ogDescription && <meta name="twitter:description" content={ogDescription} />}
			{ogImage && <meta property="og:image" content={ogImage} />}
			{ogImage && <meta name="twitter:image" content={ogImage} />}
			{ogImage && <meta name="twitter:card" content="summary_large_image" />}
		</Helmet>
	);
}
